import React from "react";
import { useTranslation } from 'react-i18next';
import { useCurrentUser } from '../../../contexts/CurrentUser';
import { platformNamesMapping, platformMapping, availablePlatforms} from '../../../utils/platforms';

import './Filter.scss';

type PlatformChooserProps = {
  selected: number[];
  onChange: (selected: number[]) => void;
  disabled?: boolean;
  className?: string;
  style?: React.CSSProperties;
};

export const PlatformChooser: React.FC<PlatformChooserProps> = ({
  selected,
  onChange,
  disabled = false,
  className = "",
  style = {},
}) => {
  const { t } = useTranslation();
  const [currentUser] = useCurrentUser();
  const workspaceConfig = currentUser?.workspace?.config;
  const availablePlatformsConfig = workspaceConfig?.available_platforms || [];

  let platformList: { name: string; value: number | string }[] = [];
  
  if (availablePlatformsConfig?.length > 0) {
    platformList = availablePlatformsConfig.map(platform => ({
      name: platformNamesMapping[platform] || platform,
      value: platformMapping[platform] || platform,
    }));
  }
  else {
    platformList = availablePlatforms.map(platform => ({
      name: platformNamesMapping[platform] || platform,
      value: platformMapping[platform] || platform,
    }));
  }

  const handleSelect = () => {
    if (platformList.length === selected.length) {
      onChange([]);
    } else {
      onChange(platformList.map(p => Number(p.value)));
    }
  };

  return(
    <div className={`chooser ${className}`} style={style}>
      <div className="control" onClick={disabled ? undefined : handleSelect}>
        {platformList.length === selected.length ? t("Deselect all") : t("Select all")}
      </div>
      <ul>
        {platformList.map(platform => (
          <li key={platform.value}>
            <input
              id={`platform_${platform.value}`}
              type="checkbox"
              checked={selected.includes(Number(platform.value))}
              disabled={disabled}
              onChange={() => {
                if (selected.includes(Number(platform.value))) {
                  onChange(selected.filter(v => v !== Number(platform.value)));
                } else {
                  onChange([...selected, Number(platform.value)]);
                }
              }}
            />
            <label htmlFor={`platform_${platform.value}`}>{platform.name}</label>
          </li>
        ))}
      </ul>
    </div>
  )
}